// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__CKE4o","choiceBoxes":"toolbarselects_choiceBoxes__3kSEr","simpleField":"toolbarselects_simpleField__1ji48"};